import { combineReducers } from 'redux';
import userProfileReducer from './user-profile.slice'

const userRootReducer = combineReducers({
    profile: userProfileReducer
});

export default userRootReducer;